var map = {
	"./astronaut.png": "0c7f",
	"./bagel.png": "3078",
	"./bloody.png": "5668",
	"./corndog.png": "4e1c",
	"./hamburger.png": "3b93",
	"./launch.png": "725f",
	"./minicorndogs.png": "110c",
	"./planet.png": "f8c4",
	"./rocket.png": "60a8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b967";